"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _spacing = _interopRequireDefault(require("./spacing"));

/*
  This is a special component that uses the same spacing as if you are doing:

  Container
    Row
      Cell(fullWidth)
        Stuff1
    Row
      Cell(fullWidth)
        Stuff2
    Row
      Cell(fullWidth)
        Stuff3

  Instead use:

  Block
    Stuff1
    Stuff2
    Stuff3
*/
var Block = (
/*#__PURE__*/
0, _styledBase["default"])('div', {
  target: "e10dzewx0",
  label: "Block"
})("> *{margin:0 0 ", _spacing["default"].Medium, " 0;}>:last-child{margin:0;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9MYXlvdXQvQmxvY2suanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBeUIyQiIsImZpbGUiOiIuLi8uLi9zcmMvTGF5b3V0L0Jsb2NrLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IFNwYWNpbmcgZnJvbSAnLi9zcGFjaW5nJztcblxuLypcbiAgVGhpcyBpcyBhIHNwZWNpYWwgY29tcG9uZW50IHRoYXQgdXNlcyB0aGUgc2FtZSBzcGFjaW5nIGFzIGlmIHlvdSBhcmUgZG9pbmc6XG5cbiAgQ29udGFpbmVyXG4gICAgUm93XG4gICAgICBDZWxsKGZ1bGxXaWR0aClcbiAgICAgICAgU3R1ZmYxXG4gICAgUm93XG4gICAgICBDZWxsKGZ1bGxXaWR0aClcbiAgICAgICAgU3R1ZmYyXG4gICAgUm93XG4gICAgICBDZWxsKGZ1bGxXaWR0aClcbiAgICAgICAgU3R1ZmYzXG5cbiAgSW5zdGVhZCB1c2U6XG5cbiAgQmxvY2tcbiAgICBTdHVmZjFcbiAgICBTdHVmZjJcbiAgICBTdHVmZjNcbiovXG5cbmNvbnN0IEJsb2NrID0gc3R5bGVkKCdkaXYnKWBcbiAgPiAqIHtcbiAgICBtYXJnaW46IDAgMCAke1NwYWNpbmcuTWVkaXVtfSAwO1xuICB9XG5cbiAgPiA6bGFzdC1jaGlsZCB7XG4gICAgbWFyZ2luOiAwO1xuICB9XG5gO1xuXG5CbG9jay5kaXNwbGF5TmFtZSA9ICdCbG9jayc7XG5cbmV4cG9ydCBkZWZhdWx0IEJsb2NrO1xuIl19 */"));
Block.displayName = 'Block';
var _default = Block;
exports["default"] = _default;